import { ADD_PHOTO } from '../actionTypes'

export const addAlbumPhoto = (data: object) => ({
  type: ADD_PHOTO.name,
  api: {
    url: 'album_photos/add',
    data,
  },
})
